import { OperationType } from '@/shared/lib/sj-orm';
import { SyncQueueJobMethod } from '@/shared/lib/sj-orm/synchronizer/types';

export const getJobMethodByOperationType = (
  type: OperationType,
):
  | SyncQueueJobMethod.ADD_ITEM
  | SyncQueueJobMethod.CHANGE_ITEM
  | SyncQueueJobMethod.REMOVE_ITEM => {
  switch (type) {
    case OperationType.ADD:
      return SyncQueueJobMethod.ADD_ITEM;
    case OperationType.CHANGE:
      return SyncQueueJobMethod.CHANGE_ITEM;
    case OperationType.REMOVE:
      return SyncQueueJobMethod.REMOVE_ITEM;
    default:
      throw new Error('Invalid OperationType');
  }
};
